import request from '@/utils/request'

export function fetchList(query) {
    return request({
        url: '/admin/department/list',
        method: 'get',
        params: query
    })
}

export function save(data) {
    return request({
        url: '/admin/department/save',
        method: 'post',
        data
    })
}

export function batchUpdate(data) {
    return request({
        url: '/admin/department/batchUpdate',
        method: 'post',
        data
    })
}
